
const params = new URLSearchParams(window.location.search);
export const streamKey = params.get('key') ?? 'missing_key';
export const backendAPI = params.get('backendAPI') ?? 'missing_backendAPI';
export const userID = params.get('userID') ?? 'missing_userID';

export const avatarTestPage = window.location.search.includes('avatar-test');